import React, { FC } from 'react';
import styled from 'styled-components';

import ConfirmationModal, {
  ConfirmationModalSize,
} from 'src/presentation/components/pages/shared/modals/ConfirmationModal';

type FBConfirmationModalProps = {
  description: string;
  selectedFBPages: any;
  onConfirmationOk: Function;
  onConfirmationCancel: Function;
  title: string;
  warningContent?: React.ReactElement;
};

const FBConfirmationModal: FC<FBConfirmationModalProps> = ({
  description,
  selectedFBPages,
  onConfirmationCancel,
  onConfirmationOk,
  title,
  warningContent,
}) => {
  return (
    <ConfirmationModal
      modalSize={ConfirmationModalSize.SMALL}
      content={
        <ConfirmationModalContent
          description={description}
          selectedFbPages={selectedFBPages}
          warningContent={warningContent}
        />
      }
      onCancel={onConfirmationCancel}
      onOk={onConfirmationOk}
      title={title}
    />
  );
};

export default FBConfirmationModal;

type FBConfirmationModalContentProps = {
  description;
  selectedFbPages: any;
  warningContent?: React.ReactElement;
};

const ConfirmationModalContent: FC<FBConfirmationModalContentProps> = ({
  description,
  selectedFbPages,
  warningContent,
}) => {
  return (
    <>
      <p>{description}</p>
      {selectedFbPages.length !== 0 ? <PageList header={'Selected pages'} fbPages={selectedFbPages} /> : null}
      {warningContent || null}
    </>
  );
};

type PageListProps = {
  header: string;
  fbPages: any;
};

const PageList: FC<PageListProps> = ({ header, fbPages }) => (
  <>
    <b>{header}</b>
    <UL>
      {fbPages.map(fbPage => (
        <li key={fbPage.id}>{fbPage.name}</li>
      ))}
    </UL>
  </>
);

const UL = styled.ul`
  padding: 0;
  list-style-type: none;
`;
